import { render } from "./timeSlotRenderer.vue?vue&type=template&id=22fabcbc"
import script from "./timeSlotRenderer.vue?vue&type=script&lang=js"
export * from "./timeSlotRenderer.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Top\\Work\\Impelos\\Repos\\load-manager\\loadSheet\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__